
import { Vue, Component, Prop } from 'vue-property-decorator';
import html2canvas from 'html2canvas';
import { Button } from 'vant';

Vue.use(Button);
@Component
export default class Poster extends Vue {
  @Prop() item!: any;
  dataURL = '';

  handClickAction() {
    this.toImage();
  }
  mounted() {
    // setTimeout(() => {
    //   this.toImage();
    // }, 1000);
  }
  toImage() {
    document.documentElement.scrollTop = 0;
    const dom = document.getElementById('posterWrap');

    const that = this;
    const width = (this.$refs.imageTofile as HTMLDivElement).offsetWidth;
    const height = (this.$refs.imageTofile as HTMLDivElement).offsetHeight;
    // const proxyURL = this.item.pictures[0]
    const config: any = {
      useCORS: true,
      // scale: 2,
      // timeout: 300,
      // scrollX: 0,
      // scrollY: 0,
      logging: true,
      backgroundColor: null, // 避免图片有白色边框
    };
    // 第一个参数是需要生成截图的元素,第二个是自己需要配置的参数,宽高等
    html2canvas(this.$refs.imageTofile as any, config).then((canvas) => {
      const dataURL = canvas.toDataURL('image/jpeg', 1);
      (this.$refs.imageTofile as HTMLDivElement).append(canvas);
      that.dataURL = dataURL;
    });
  }
}
